export const categories = [
  {
    id: "celebrity-gossip",
    slug: "celebrity-gossip",
    name: "明星黑料",
    description: "娱乐圈明星不为人知的秘密，独家爆料一手掌握",
    metaTitle: "明星黑料专区 - 51CG吃瓜最新爆料与深度追踪",
    metaDescription: "汇聚娱乐圈明星黑料、不为人知的秘密与独家爆料，51CG吃瓜为您实时更新最新明星八卦与深度解析。",
    keywords: "明星黑料, 娱乐圈爆料, 明星八卦, 51CG吃瓜, 独家爆料",
    articleCount: 128,
    image: "https://readdy.ai/api/search-image?query=Abstract%20dark%20celebrity%20silhouette%20with%20neon%20lime%20green%20warning%20stripes%20and%20gossip%20headlines%20texture%2C%20modern%20digital%20art%20style%2C%20high%20contrast%2C%20entertainment%20news%20aesthetic&width=800&height=500&seq=cat-celebrity-01&orientation=landscape",
  },
  {
    id: "hot-gossip",
    slug: "hot-gossip",
    name: "热门吃瓜",
    description: "全网最热的吃瓜事件，实时追踪网友热议话题",
    metaTitle: "热门吃瓜专区 - 51CG全网最热事件实时追踪",
    metaDescription: "汇集全网最热门的吃瓜事件、社交舆论焦点与网友热议话题，51CG吃瓜为您提供实时更新的热门资讯。",
    keywords: "热门吃瓜, 全网热议, 吃瓜事件, 51CG吃瓜, 热点追踪",
    articleCount: 256,
    image: "https://readdy.ai/api/search-image?query=Abstract%20explosive%20hot%20trending%20topic%20visualization%20with%20lime%20green%20energy%20bursts%20and%20dark%20charcoal%20background%2C%20social%20media%20buzz%20concept%20art%2C%20dynamic%20composition%2C%20modern%20digital%20illustration&width=800&height=500&seq=cat-hot-01&orientation=landscape",
  },
  {
    id: "deep-analysis",
    slug: "deep-analysis",
    name: "深度解析",
    description: "不只是吃瓜，更有专业视角的深度分析与真相还原",
    metaTitle: "深度解析专区 - 51CG吃瓜专业视角还原事件真相",
    metaDescription: "51CG吃瓜深度解析频道，提供专业视角的事件分析、真相还原与理性解读，让您吃瓜更透彻。",
    keywords: "深度解析, 事件分析, 真相还原, 51CG吃瓜, 专业解读",
    articleCount: 86,
    image: "https://readdy.ai/api/search-image?query=Abstract%20magnifying%20glass%20revealing%20hidden%20layers%20of%20truth%20with%20lime%20green%20glow%20and%20dark%20background%2C%20investigation%20concept%20art%2C%20mysterious%20atmosphere%2C%20modern%20digital%20illustration%20style&width=800&height=500&seq=cat-deep-01&orientation=landscape",
  },
  {
    id: "entertainment-leaks",
    slug: "entertainment-leaks",
    name: "娱乐爆料",
    description: "圈内人士一手爆料，娱乐圈内幕大公开",
    metaTitle: "娱乐爆料专区 - 51CG圈内人士一手内幕大公开",
    metaDescription: "51CG吃瓜娱乐爆料频道，汇集圈内人士一手爆料、娱乐圈内幕消息与独家资讯，让您掌握第一手娱乐动态。",
    keywords: "娱乐爆料, 圈内内幕, 独家消息, 51CG吃瓜, 娱乐动态",
    articleCount: 167,
    image: "https://readdy.ai/api/search-image?query=Abstract%20secret%20document%20leak%20visualization%20with%20lime%20green%20paper%20fragments%20floating%20in%20dark%20space%2C%20whistleblower%20concept%20art%2C%20dramatic%20lighting%2C%20modern%20digital%20illustration&width=800&height=500&seq=cat-leaks-01&orientation=landscape",
  },
  {
    id: "maury-show",
    slug: "maury-show",
    name: "莫里秀找爹",
    description: "经典莫里秀找爹系列，情感纠葛与亲子鉴定大戏",
    metaTitle: "莫里秀找爹专区 - 51CG经典亲子鉴定与情感纠葛",
    metaDescription: "51CG吃瓜莫里秀找爹专区，汇集经典亲子鉴定节目、情感纠葛大戏与网友热议，让您笑中带泪看人性。",
    keywords: "莫里秀找爹, 亲子鉴定, 情感纠葛, 51CG吃瓜, 经典综艺",
    articleCount: 54,
    image: "https://readdy.ai/api/search-image?query=Abstract%20family%20drama%20theater%20stage%20with%20lime%20green%20spotlight%20and%20dark%20dramatic%20backdrop%2C%20emotional%20confrontation%20concept%20art%2C%20tv%20show%20aesthetic%2C%20modern%20digital%20illustration&width=800&height=500&seq=cat-maury-01&orientation=landscape",
  },
];